import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import LightingSetDetail from '../../components/light/LightingSetDetail';
import { editLightingSet, getLightingSet } from '../../redux/luminaire/lightingset_actions';
import { defaultRejectHandler } from '../../utils/utility';

class LightingSetEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.lightingSetDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ls !== nextProps.ls && nextProps.show) {
      this.props.getLS(nextProps.ls.id);
    }
  }

  onSaveHandler() {
    const editedLightingSet = this.lightingSetDetail.getWrappedInstance().getWrappedInstance().getLSData();
    this.props.editLightingSet({ ...editedLightingSet, id: this.props.ls.id });
  }

  render() {
    const { isEditing, lsDetail, errorMessage, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('edit lighting set')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LightingSetDetail
            lightingSet={lsDetail}
            mode={'edit'}
            ref={ref => (this.lightingSetDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="lighting-set-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => {
  const lightingSetState = state.lighting.lightingset;
  return {
    errorMessage: lightingSetState.errorMessage,
    isEditing: lightingSetState.isEditing,
    lsDetail: props.ls && lightingSetState.objects[props.ls.id],
  };
};

const mapDispatchToProps = dispatch => ({
  getLS: id => defaultRejectHandler(dispatch(getLightingSet(id))),
  editLightingSet: lightingset =>
    defaultRejectHandler(
      dispatch(
        editLightingSet(
          lightingset.id,
          lightingset.name,
          lightingset.description || '',
          lightingset.image,
        ),
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(LightingSetEditModal)
);


// WEBPACK FOOTER //
// ./src/modal/lighting_set/LightingSetEditModal.js